{
  "AUTOMATION": {
    "HEADER": "Automatisierung",
    "DESCRIPTION": "Mittels Automatisierung können bestehende Prozesse ersetzt und rationalisiert werden, die manuellen Aufwand erfordern, z. B. das Hinzufügen von Etiketten und die Zuweisung von Gesprächen an den am besten geeigneten Agenten. So kann sich das Team auf seine Stärken konzentrieren und gleichzeitig den Zeitaufwand für Routineaufgaben reduzieren.",
    "LEARN_MORE": "Learn more about automation",
    "HEADER_BTN_TXT": "Automatisierungsregel hinzufügen",
    "LOADING": "Automatisierungsregeln abrufen",
    "ADD": {
      "TITLE": "Automatisierungsregel hinzufügen",
      "SUBMIT": "Erstellen",
      "CANCEL_BUTTON_TEXT": "Abbrechen",
      "FORM": {
        "NAME": {
          "LABEL": "Regelname",
          "PLACEHOLDER": "Regelnamen eingeben",
          "ERROR": "Name wird benötigt"
        },
        "DESC": {
          "LABEL": "Beschreibung",
          "PLACEHOLDER": "Regelbeschreibung eingeben",
          "ERROR": "Beschreibung wird benötigt"
        },
        "EVENT": {
          "LABEL": "Ereignis",
          "PLACEHOLDER": "Bitte auswählen",
          "ERROR": "Ereignis ist erforderlich"
        },
        "CONDITIONS": {
          "LABEL": "Bedingungen"
        },
        "ACTIONS": {
          "LABEL": "Aktionen"
        },
        "PHASE": {
          "LABEL": "Phase"
        },
        "ORDER": {
          "LABEL": "Reihenfolge",
          "ERROR": "Reihenfolge ist erforderlich"
        }
      },
      "CONDITION_BUTTON_LABEL": "Bedingung hinzufügen",
      "ACTION_BUTTON_LABEL": "Aktion hinzufügen",
      "API": {
        "SUCCESS_MESSAGE": "Automatisierungsregel erfolgreich hinzugefügt",
        "ERROR_MESSAGE": "Automatisierungsregel konnte nicht erstellt werden. Bitte versuchen Sie es später erneut"
      }
    },
    "LIST": {
      "404": "Keine Automatisierungsregeln gefunden",
      "TABLE_HEADER": {
        "NAME": "Name",
        "DESCRIPTION": "Beschreibung",
        "ACTIVE": "Aktiv",
        "CREATED_ON": "Erstellt am",
        "PHASE": "Phase",
        "ORDER": "Reihenfolge",
        "WAIT": "Wartezeit"
      },
      "TABS": {
        "ALL": "Alle",
        "INSTANT": "Bei Ereignis",
        "DELAYED": "Verzögert"
      },
      "WAITS": "Wartet {duration}"
    },
    "DELETE": {
      "TITLE": "Automatisierungsregel löschen",
      "SUBMIT": "Löschen",
      "CANCEL_BUTTON_TEXT": "Abbrechen",
      "CONFIRM": {
        "TITLE": "Löschung bestätigen",
        "MESSAGE": "Bist du sicher, dass du das löschen möchtest ",
        "YES": "Ja, löschen ",
        "NO": "Nein, behalten "
      },
      "API": {
        "SUCCESS_MESSAGE": "Automatisierungsregel erfolgreich gelöscht",
        "ERROR_MESSAGE": "Eine Automatisierungsregel konnte nicht gelöscht werden. Bitte versuchen Sie es später erneut"
      }
    },
    "EDIT": {
      "TITLE": "Automatisierungsregel bearbeiten",
      "SUBMIT": "Aktualisieren",
      "CANCEL_BUTTON_TEXT": "Abbrechen",
      "API": {
        "SUCCESS_MESSAGE": "Automatisierungsregel erfolgreich aktualisiert",
        "ERROR_MESSAGE": "Die Automatisierungsregel konnte nicht aktualisiert werden. Bitte versuchen Sie es später erneut"
      }
    },
    "CLONE": {
      "TOOLTIP": "Klonen",
      "API": {
        "SUCCESS_MESSAGE": "Automatisierung erfolgreich geklont",
        "ERROR_MESSAGE": "Die Automatisierungsregel konnte nicht geklont werden. Bitte später erneut versuchen"
      }
    },
    "FORM": {
      "EDIT": "Bearbeiten",
      "CREATE": "Erstellen",
      "DELETE": "Löschen",
      "CANCEL": "Abbrechen",
      "RESET_MESSAGE": "Durch das Ändern des Ereignistyps werden die unten hinzugefügten Bedingungen und Ereignisse zurückgesetzt"
    },
    "CONDITION": {
      "DELETE_MESSAGE": "Du musst mindestens eine Bedingung zum Speichern haben",
      "CONTACT_CUSTOM_ATTR_LABEL": "Benutzerdefinierte Kontakt-Attribute",
      "CONVERSATION_CUSTOM_ATTR_LABEL": "Benutzerdefinierte Konversations-Attribute"
    },
    "ACTION": {
      "DELETE_MESSAGE": "Zum Speichern ist mindestens eine Aktion erforderlich",
      "TEAM_MESSAGE_INPUT_PLACEHOLDER": "Geben Sie hier Ihre Nachricht ein",
      "TEAM_DROPDOWN_PLACEHOLDER": "Teams auswählen",
      "EMAIL_INPUT_PLACEHOLDER": "E-Mail eingeben",
      "URL_INPUT_PLACEHOLDER": "URL eingeben",
      "SENDER_DROPDOWN_PLACEHOLDER": "E-Mail-Posteingang und Absenderadresse auswählen",
      "SUBJECT_INPUT_PLACEHOLDER": "E-Mail-Betreff",
      "SMS_INBOX_DROPDOWN_PLACEHOLDER": "SMS-Posteingang für den Versand auswählen",
      "SMS_MESSAGE_INPUT_PLACEHOLDER": "SMS-Text eingeben",
      "SMS_COUNTER": "{length}/{limit} Zeichen, {segments} SMS (bevor die Variablen ersetzt werden)"
    },
    "TOGGLE": {
      "ACTIVATION_TITLE": "Automatisierungsregel aktivieren",
      "DEACTIVATION_TITLE": "Automatisierungsregel deaktivieren",
      "ACTIVATION_DESCRIPTION": "Diese Aktion aktiviert die Automatisierungsregel '{automationName}'. Sind Sie sicher, dass Sie fortfahren möchten?",
      "DEACTIVATION_DESCRIPTION": "Diese Aktion deaktiviert die Automatisierungsregel '{automationName}'. Sind Sie sicher, dass Sie fortfahren möchten?",
      "ACTIVATION_SUCCESFUL": "Automatisierungsregel erfolgreich aktiviert",
      "DEACTIVATION_SUCCESFUL": "Automatisierungsregel erfolgreich deaktiviert",
      "ACTIVATION_ERROR": "Automatisierung konnte nicht aktiviert werden. Bitte versuchen Sie es später erneut",
      "DEACTIVATION_ERROR": "Die Automatisierung konnte nicht deaktiviert werden. Bitte versuchen Sie es später erneut",
      "CONFIRMATION_LABEL": "Ja",
      "CANCEL_LABEL": "Nein"
    },
    "ATTACHMENT": {
      "UPLOAD_ERROR": "Anhang konnte nicht hochgeladen werden, bitte versuchen Sie es erneut",
      "LABEL_IDLE": "Anhang hochladen",
      "LABEL_UPLOADING": "Hochladen...",
      "LABEL_UPLOADED": "Erfolgreich hochgeladen",
      "LABEL_UPLOAD_FAILED": "Upload fehlgeschlagen"
    },
    "ATTRIBUTES": {
      "EXTENSION": "Angerufene Durchwahl",
      "AI_FILTER": "AI-Filter",
      "MESSAGE_TYPE": "Nachrichtentyp",
      "MESSAGE_CONTAINS": "Nachricht enthält",
      "EMAIL": "Kontakt-E-Mail",
      "INBOX": "Posteingang",
      "CHANNEL_TYPE": "Posteingangstyp",
      "CONVERSATION_LANGUAGE": "Konversationssprache",
      "PHONE_NUMBER": "Telefonnummer",
      "STATUS": "Status",
      "BROWSER_LANGUAGE": "Browsersprache",
      "MAIL_SUBJECT": "Mail-Betreff",
      "COUNTRY_NAME": "Landesname",
      "MARKETPLACE_COUNTRY": "Marketplace-Land",
      "REFERER_LINK": "Verweis-Link",
      "ASSIGNEE_NAME": "Name des Bevollmächtigten",
      "TEAM_NAME": "Teamname",
      "PRIORITY": "Priorität",
      "CALL_DIRECTION": "Anrufrichtung",
      "MISSED_CALL": "Verpasster Anruf",
      "MISSED_CALL_COUNT": "Anzahl verpasster Anrufe",
      "MESSAGE_SOURCE_TYPE": "Nachrichtenquellentyp",
      "INCOMING_MESSAGE_COUNT": "Anzahl eingehender Nachrichten",
      "OUTGOING_MESSAGE_COUNT": "Anzahl ausgehender Nachrichten",
      "LABEL": "Label",
      "EMAIL_RECIPIENTS": "E-Mail-Empfänger",
      "EMAIL_AUTO_REPLY": "E-Mail ist eine automatische Antwort",
      "ATTACHMENT_EXTENSION": "Dateiendung des Anhangs",
      "WORKING_HOURS": "Innerhalb der Öffnungszeiten",
      "AGENT_REPLIED": "Agent hat seit der Statusänderung geantwortet"
    },
    "ERRORS": {
      "ATTRIBUTE_KEY_REQUIRED": "Attribut-Schlüssel ist erforderlich",
      "FILTER_OPERATOR_REQUIRED": "Filter-Operator ist erforderlich",
      "VALUE_REQUIRED": "Wert ist erforderlich",
      "VALUE_MUST_BE_BETWEEN_1_AND_998": "Wert muss zwischen 1 und 998 liegen",
      "ACTION_PARAMETERS_REQUIRED": "Aktionsparameter sind erforderlich",
      "ATLEAST_ONE_CONDITION_REQUIRED": "Mindestens eine Bedingung ist erforderlich",
      "ATLEAST_ONE_ACTION_REQUIRED": "Mindestens eine Aktion ist erforderlich",
      "VALUE_MUST_BE_BETWEEN_0_AND_998": "Wert muss zwischen 0 und 998 liegen",
      "ORDER_REQUIRED": "Reihenfolge ist erforderlich",
      "ORDER_MUST_BE_AT_LEAST_ONE": "Reihenfolge muss mindestens 1 sein"
    },
    "NONE_OPTION": "Keine",
    "ACTION_NOTICES": {
      "SKIP_AUTO_PRIORITY": "Diese Aktion funktioniert nur, wenn die Regelphase auf 'Vor der Kennzeichnung' gesetzt ist.",
      "SKIP_AUTO_LABELING": "Diese Aktion funktioniert nur, wenn die Regelphase auf 'Vor der Kennzeichnung' gesetzt ist.",
      "MOVE_CONVERSATION_TO_INBOX": "Nur E-Mail- und Webchat-Unterhaltungen können in einen E-Mail-Posteingang verschoben werden, ein Webchat nur, wenn der Kontakt eine E-Mail-Adresse hat. Andernfalls bleibt die Unterhaltung, wo sie ist, und stattdessen wird eine private Notiz hinzugefügt.",
      "SEND_MESSAGE_IN_NEW_CONVERSATION": "Startet mit dem Kontakt eine neue Unterhaltung im ausgewählten E-Mail-Posteingang, sendet ihm die Nachricht per E-Mail und markiert die Unterhaltung als gelöst. Das geschieht bei jeder Ausführung der Regel. Hat der Kontakt keine E-Mail-Adresse, wird nichts gesendet und stattdessen eine private Notiz hinzugefügt.",
      "SEND_SMS_IN_NEW_CONVERSATION": "Startet mit dem Kontakt eine neue Unterhaltung im ausgewählten SMS-Posteingang, sendet ihm die Nachricht per SMS und markiert die Unterhaltung als gelöst. Das geschieht bei jeder Ausführung der Regel. Die Nachricht ist reiner Text ohne Anhänge. Hat der Kontakt keine Telefonnummer, wird nichts gesendet und stattdessen eine private Notiz hinzugefügt."
    },
    "NOTICES": {
      "AI_PROMPT": "Jede einzelne Auswertung wird berechnet.",
      "INCOMING_MESSAGES_COUNT": "Dies bezieht sich auf die Anzahl der eingehenden Nachrichten in der Unterhaltung.",
      "OUTGOING_MESSAGES_COUNT": "Dies bezieht sich auf die Anzahl der ausgehenden Nachrichten in der Unterhaltung."
    },
    "PHASE": {
      "BEFORE_LABELING": "Vor der Kennzeichnung",
      "AFTER_LABELING": "Nach der Kennzeichnung"
    },
    "MESSAGE_TYPE_VALUES": {
      "INCOMING": "Eingehende Nachricht",
      "OUTGOING": "Ausgehende Nachricht",
      "PRIVATE": "Private Notiz",
      "AI_SUMMARY": "KI-Zusammenfassung"
    },
    "YES_NO_VALUES": {
      "YES": "Ja",
      "NO": "Nein"
    },
    "MESSAGE_SOURCE_TYPE_VALUES": {
      "FACEBOOK_MESSENGER": "Facebook Messenger",
      "INSTAGRAM_DM": "Instagram-Direktnachricht",
      "FACEBOOK_COMMENT": "Facebook-Kommentar"
    },
    "EVENTS": {
      "CONVERSATION_CREATED": "Unterhaltung erstellt",
      "CONVERSATION_UPDATED": "Unterhaltung aktualisiert",
      "MESSAGE_CREATED": "Nachricht erstellt",
      "CONVERSATION_OPENED": "Unterhaltung geöffnet",
      "CONVERSATION_RESOLVED": "Unterhaltung gelöst",
      "PHONE_CALL_FINISHED": "Anruf beendet"
    },
    "ACTIONS": {
      "ASSIGN_AGENT": "Agent zuweisen",
      "ASSIGN_TEAM": "Team zuweisen",
      "ADD_LABEL": "Label hinzufügen",
      "REMOVE_LABEL": "Label entfernen",
      "SEND_EMAIL_TO_TEAM": "E-Mail an Team senden",
      "SEND_EMAIL_TRANSCRIPT": "E-Mail-Transkript senden",
      "SEND_EMAIL_TRANSCRIPT_WITH_DETAILS": "Detailliertes E-Mail-Transkript senden",
      "MUTE_CONVERSATION": "Unterhaltung stummschalten",
      "SNOOZE_CONVERSATION": "Unterhaltung zurückstellen",
      "RESOLVE_CONVERSATION": "Unterhaltung lösen",
      "OPEN_CONVERSATION": "Unterhaltung öffnen",
      "SEND_WEBHOOK_EVENT": "Webhook-Ereignis senden",
      "SEND_ATTACHMENT": "Anhang senden",
      "SEND_MESSAGE": "Nachricht senden",
      "ADD_NOTE": "Notiz hinzufügen",
      "CHANGE_PRIORITY": "Priorität ändern",
      "ADD_SLA": "SLA hinzufügen",
      "SKIP_AUTO_PRIORITY": "Automatische Priorität überspringen",
      "SKIP_AUTO_LABELING": "Automatische Kennzeichnung überspringen",
      "AUTO_TRANSLATE": "Nachricht übersetzen",
      "AUTO_TRANSLATE_CONVERSATION": "Unterhaltung übersetzen",
      "MOVE_CONVERSATION_TO_INBOX": "Unterhaltung in Posteingang verschieben",
      "SEND_MESSAGE_IN_NEW_CONVERSATION": "Nachricht in neuer Unterhaltung senden",
      "SEND_SMS_IN_NEW_CONVERSATION": "SMS in neuer Unterhaltung senden",
      "STOP_PROCESSING_RULES": "Regelverarbeitung stoppen"
    },
    "WAIT": {
      "RUN_LABEL": "Aktionen ausführen",
      "INSTANT": "Bei Ereignis",
      "DELAYED": "Verzögert",
      "TRIGGER_LABEL": "Warten, bis",
      "TRIGGERS": {
        "CONVERSATION_STATUS": "Eine Konversation bleibt in einem Status",
        "CUSTOMER_UNRESPONSIVE": "Der Kunde antwortet einem Agenten nicht",
        "AGENT_UNRESPONSIVE": "Der Kunde erhält keine Antwort eines Agenten"
      },
      "STATUS_LABEL": "Status",
      "STATUSES": {
        "OPEN": "Offen",
        "PENDING": "Ausstehend",
        "SNOOZED": "Zurückgestellt",
        "RESOLVED": "Gelöst"
      },
      "DELAY_LABEL": "Wartezeit",
      "DELAY_ERROR": "Geben Sie eine Wartezeit zwischen 1 Minute und 30 Tagen ein",
      "DURATION": {
        "MINUTES": "{count} Min.",
        "HOURS": "{count} Std.",
        "DAYS": "{count} T."
      },
      "EXPLANATION": {
        "CONVERSATION_STATUS": "Die Aktionen werden ausgeführt, wenn eine Konversation {duration} lang den Status {status} hat. Eine Statusänderung davor bricht sie ab. Labels, Öffnungszeiten und Antworten von Agenten werden geprüft, wenn die Wartezeit endet.",
        "CUSTOMER_UNRESPONSIVE": "Die Aktionen werden ausgeführt, wenn der Kunde {duration} lang nicht auf die Nachricht eines Agenten geantwortet hat. Eine Antwort des Kunden bricht sie ab; eine neue Nachricht des Agenten startet die Wartezeit neu.",
        "AGENT_UNRESPONSIVE": "Die Aktionen werden ausgeführt, wenn der Kunde {duration} ohne Antwort eines Agenten gewartet hat. Eine Antwort des Agenten bricht sie ab."
      }
    }
  }
}
